package com.wintermar.inspection.core.ui.component.badge.variant

import androidx.compose.runtime.Composable
import com.wintermar.inspection.core.ui.theme.LocalAppTheme

sealed class BadgeSizeVariant {
    @Composable
    abstract fun size(): BadgeSizeModel

    object Small : BadgeSizeVariant() {
        @Composable
        override fun size(): BadgeSizeModel {
            val dimension = LocalAppTheme.current.dimension
            return BadgeSizeModel(
                iconSize = dimension.size.icon.xs,
                verticalPadding = dimension.spacing.space1,
                horizontalPadding = dimension.spacing.space2
            )
        }
    }

    object Medium : BadgeSizeVariant() {
        @Composable
        override fun size(): BadgeSizeModel {
            val dimension = LocalAppTheme.current.dimension
            return BadgeSizeModel(
                iconSize = dimension.size.icon.xs,
                verticalPadding = dimension.spacing.space2,
                horizontalPadding = dimension.spacing.space2
            )
        }
    }

    object Large : BadgeSizeVariant() {
        @Composable
        override fun size(): BadgeSizeModel {
            val dimension = LocalAppTheme.current.dimension
            return BadgeSizeModel(
                iconSize = dimension.size.icon.s,
                verticalPadding = dimension.spacing.space2,
                horizontalPadding = dimension.spacing.space3
            )
        }
    }
}
